import React, { useState, useEffect, useRef } from "react";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import withReactContent from "sweetalert2-react-content";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { Container } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import axios from "axios";
import loading from "../../assets/img/loading-gif.gif";
import pdf from "../../assets/img/pdficon.png";
import mic from "../../assets/img/mic.png";
import { Link } from "react-router-dom";
import { AudioRecorder, useAudioRecorder } from "react-audio-voice-recorder";
import { render } from "react-dom";
import VideoRecorder from "react-video-recorder";
import $ from "jquery";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { VoiceRecorder } from "react-voice-recorder-player";
import logo from '../../assets/img1/image_2025_02_11T07_23_59_242Z.png';
import io from 'socket.io-client'; // Import socket.io-client

const SOCKET_URL = "https://api.Cash365days.in/"; // Replace with your server URL

export default function Gameposting() {
  const [isRecording, setIsRecording] = useState(false);
  const [file, setFile] = useState(null);
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [showSubmitButton, setShowSubmitButton] = useState(true);
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [isInputFocuseddd, setIsInputFocuseddd] = useState(false);
  const [loadingbuttonaudio, setLoadingbuttonaudio] = useState(false);
  const [recordedData, setRecordedData] = useState(null);
  const [recordurl, setRecordeurl] = useState(null);
  const [receiverId, setChatlistadmin] = useState('');
  const storedToken = localStorage.getItem("adminToken");
  const AdminName = localStorage.getItem("username");
  const isAdmin = localStorage.getItem("isAdmin");
  const [MessageType, setMessageType] = useState("withdraw");
  const guestId = localStorage.getItem('userid');
  const [username, setUsername] = useState(AdminName || guestId);
  const [message, setMessage] = useState("");
  const [chat, setChat] = useState([]);
  const [socket, setSocket] = useState(null); // Use socket instead of ws
  const [ChatUpdate, setChatUpdate] = useState(false);
  const [audioBlob, setAudioBlob] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const isAdmined = localStorage.getItem("isAdmin");
  const userTokened = localStorage.getItem("userToken");
  useEffect(() => {
  
    if (!userTokened  || !isAdmined === "false") {
      navigate("/");
      localStorage.clear();
    }
  }, [!isAdmined]);

  const allowedFileTypes = [
    ".mp4", ".webm", ".gif", ".mkv", ".gifv", ".m4v", ".amv",
    ".pdf", ".xlsx", ".xls", ".ods", ".txt",
    ".jpg", ".jpeg", ".png", ".gif", ".bmp", ".svg", ".webp"
  ];

  const openModal = (imageUrl) => {
    setSelectedImage(imageUrl);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedImage(null);
  };


  const validateFileType = (file) => {
    const extension = file.name.split('.').pop().toLowerCase();
    return allowedFileTypes.includes(`.${extension}`);
  };

  const recorderControls = useAudioRecorder();

  useEffect(() => {
    if (!receiverId || !guestId) return; // Ensure IDs are available before setting up socket

    const newSocket = io(SOCKET_URL, {
      transports: ['polling'],
      query: { receiverId, guestId }
    });

    newSocket.on("connect", () => {
      console.warn("Connected to Socket.IO");
    });

    newSocket.on("oldMessages", (messages) => {
      const withdrawalMessages = messages.filter(
        (msg) => msg.type === "withdraw" && (msg.receiverId == receiverId  || msg.sender == receiverId) && (msg.sender === guestId || msg.receiverId == guestId)
      );
      console.warn("Chat update triggered: ", withdrawalMessages);

      if (withdrawalMessages.length > 0) {
        setChat(withdrawalMessages);
      }
    });

    newSocket.on("newMessage", (data) => {
      console.warn("Chat update triggered: ", data);

      setChat((prev) => {
        const updatedChat = [...prev, data].filter(
          (msg) => (msg.receiverId == receiverId  || msg.sender == receiverId) && (msg.sender === guestId || msg.receiverId == guestId)
        );
        return updatedChat.length > 0 ? updatedChat : prev;
      });

      if (AdminName) {
        markUnseenMessagesAsSeen();
      }
    });

    newSocket.on("disconnect", () => {
      console.log("Socket.IO disconnected");
    });

    newSocket.on("error", (error) => {
      console.error("Socket.IO error:", error);
    });

    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
  }, [receiverId, guestId]); // Ensure socket reconnects only when IDs change

  const sendMessage = async () => {
    if ((message.trim() || file || audioBlob) && socket) {
      if (file && !validateFileType(file)) {
        setMessage("");
        setFile(null);
        $(".sendmessageMic").show();
        setAudioBlob(null); // Clear audio after sending
        alert("Unsupported file type.");
        return;
      }
      const msgData = {
        sender: username,
        message: message.trim(),
        type: MessageType,
        userType: 'user',
        receiverId,
        file,
        audio: audioBlob
          ? {
            data: await blobToBase64(audioBlob), // Convert Blob to base64
            type: "audio",
          }
          : null,
        timestamp: new Date().toISOString(), // Include timestamp
      };

      console.warn(msgData);
      socket.emit("message", msgData); // Use socket.emit instead of ws.send
      setMessage("");
      $(".sendmessageMic").show();
      setFile(null);
      setAudioBlob(null); // Clear audio after sending
    }
  };
  useEffect(() => {
    if (audioBlob) {
      sendMessage();
    }
  }, [audioBlob]);
  // Helper function to convert Blob to base64
  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const handleAudioRecordingComplete = (blob) => {
    setAudioBlob(blob); // Save the recorded audio blob
  };

  const handleFileUpload = async (e) => {
    $(".sendmessageMic").hide();
    $(".sendmessage").show();
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    if (selectedFile.size >= 10 * 1024 * 1024) {
      alert("File size should be less than 10MB!");
      return;
    }
    
    const reader = new FileReader();
    reader.onload = (event) => {
      const fileData = {
        name: selectedFile.name,
        type: selectedFile.type.includes("image") ? "image" : selectedFile.type.includes("pdf") ? "pdf" : "video",
        data: event.target.result, // Base64 data
      };
      setFile(fileData);
    };
    reader.readAsDataURL(selectedFile);
  };

  const handleClick = () => {
    const element = document.querySelector("#cloesbtn");
    element.classList.add("display_none");
  };

  const [isButtonDisabled1, setIsButtonDisabled1] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const intervalRef = useRef(null);

  const addAudioElement = (blob) => {
    setIsRecording(false);
    const url = blob;
    const audio = document.createElement("audio");
    audio.src = url;
    audio.controls = true;
    document.body.appendChild(audio);
  };

  useEffect(() => {
    $(".sendmessage").hide();
    $(".sendmessageMic").show();
  }, []);

  const OnnumberChange = (e) => {
    $(".sendmessageMic").hide();
    $(".sendmessage").show();
    const mobilnumbers = e.target.value;
    setMessage(mobilnumbers);
    setIsInputFocused(mobilnumbers);
  };

  const handleClicksend = () => {
    if (!isButtonClicked) {
      setIsButtonClicked(true);
      sendMessage();
      clearInterval(intervalRef.current);
      intervalRef.current = setInterval(() => {
        clearInterval(intervalRef.current);
        setIsButtonClicked(false);
      }, 3000);
    }
  };

  const handleClickisAdmin = () => {
    if (isAdmin) {
      navigate("/HomePage");
    }
  };

  useEffect(() => {
    markUnseenMessagesAsSeen();
  }, [chat, storedToken, isAdmin]);

  const markUnseenMessagesAsSeen = () => {
    if (!storedToken || !isAdmin) return;

    const unseenMessageIds = chat
      .filter((msg) => !msg.seenByAdmin && msg.sender !== username)
      .map((msg) => msg._id);

    if (unseenMessageIds.length > 0) {
      fetch(`${process.env.REACT_APP_API_URL_NODE}messages/markAsSeen`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${storedToken}`,
        },
        body: JSON.stringify({ messageIds: unseenMessageIds }),
      });
      setChatUpdate(true);
    }
  };

  const fetchMessages = () => {
    if (!storedToken || !isAdmin) return;

    fetch(`${process.env.REACT_APP_API_URL_NODE}messages`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data)) {
          setChat(data); // Set the fetched messages into state
        }
      })
      .catch((error) => {
        console.error("❌ Error fetching messages:", error);
      });
  };

  useEffect(() => {
    fetchMessageslist();
  }, []);

  const fetchMessageslist = () => {
    fetch(`${process.env.REACT_APP_API_URL_NODE}user/list`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        setChatlistadmin(data[0]._id); // Set the fetched messages into state
        console.log(data[0]._id);
      })
      .catch((error) => {
        console.error("❌ Error fetching messages:", error);
      });
  };

  useEffect(() => {
    if (ChatUpdate) {
      fetchMessages(); // Fetch messages when `ChatUpdate` is true
      setChatUpdate(false); // Reset `ChatUpdate` state to prevent infinite loop
    }
  }, [ChatUpdate, isAdmin]); // `useEffect` will be triggered only when `ChatUpdate` changes

  return (
    <>
      {isRecording ? (
        <>
          <div className="bg-mic" id="cloesbtn">
            <button className="btn btn-close-custum" onClick={handleClick}>
              X
            </button>
            <div className="voicechange">
              <AudioRecorder
                onRecordingComplete={(blob) => addAudioElement(blob)}
                recorderControls={recorderControls}
              />
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
      <section className="chat mt-5" id="chat">
        <div className=" fixed-top">
          <div className="headerchat">
            <div className="d-flex justify-content-between align-items-center">
              <div className="headericonarrow" onClick={handleClickisAdmin}>
                <i className="bi bi-arrow-left-short"></i>
              </div>
              <div className="chatname">
                <h2>Withdraw Chat </h2>
              </div>
              <div className="logoheader">
                <img src={logo} className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="chatdesignuser1">
            <div className="chatdesignuser1">
              <div className="chat-message-group writer-user">
                <div className="chat-messages">
                  <div
                    style={{
                      padding: "10px",
                      // overflowY: "auto",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {chat.filter(msg => msg.type === 'withdraw').map((msg, index) => {
                      const isSender = msg.sender === guestId;

                      return (
                        <div key={index} className={`message_container ${isSender ? "" : "messageadmin"}`}>
                          <div>
                            <div className={`message ${isSender ? "" : "messageleft"}`}>
                              {msg.message && (
                                <p className="text-white" style={{ wordBreak: "break-all" }}>
                                  {msg.message.startsWith("http") ? (
                                    <a href={msg.message} target="_blank" rel="noopener noreferrer">
                                      {msg.message}
                                    </a>
                                  ) : (
                                    msg.message
                                  )}
                                </p>
                              )}

                              {msg.file && (
                                <div>
                                  {msg.file.type === "image" && (
                                    <img
                                      src={msg.file.url}
                                      alt="Uploaded"
                                      onClick={() =>
                                        openModal(msg.file.url)
                                      }
                                      style={{ maxWidth: "100px", borderRadius: "5px" }}
                                    />
                                  )}
                                  {msg.file.type === "video" && (
                                    <video controls src={msg.file.url} style={{ maxWidth: "200px" }} />
                                  )}

                                  {msg.file.type === "pdf" && (
                                    <>
                                      <a
                                        href={msg.file.url}
                                        rel="noopener noreferrer"
                                        className="text-dark"
                                      >
                                        {msg.imagename ? msg.imagename : msg.file.url.split('/').pop()}
                                        <img
                                          src={pdf}
                                          alt="User"
                                          style={{ width: "50px" }}
                                        />
                                      </a>
                                    </>
                                  )}
                                </div>
                              )}
                              {msg.audio && msg.audio.url && (
                                <audio controls>
                                  <source src={msg.audio.url} type="audio/mp3" />
                                  Your browser does not support the audio element.
                                </audio>
                              )}
                            </div>
                            <p className="datechat">
                              {new Date(msg.timestamp).toLocaleTimeString([], {
                                hour: "2-digit",
                                minute: "2-digit",
                              })}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex chatdesign">
            <div className="inputchat">
              <input
                type="text"
                className="form-control"
                placeholder="Type Message"
                onChange={OnnumberChange}
                value={
                  message +
                  (file
                    ? `${file.name}`
                    : recordurl
                      ? recordurl
                      : "")
                }
              />
            </div>
            <div className="buttonsend btn_file">
              <label
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <i
                  className="bi bi-paperclip"
                  style={{ transform: "rotate(60deg)", fontSize: "30px" }}
                ></i>
                <input
                  type="file"
                  onChange={handleFileUpload}
                  id="multipleFileInput"
                  style={{ display: "none" }}
                />
              </label>
            </div>
            <div className="buttonsend">
              <div className="sendmessage">
                <i
                  onClick={handleClicksend}
                  disabled={isButtonClicked || !message.trim() && !file}
                  className="bi bi-send message_send"
                >
                  {isButtonClicked && <Spinner />}
                </i>
              </div>
              <div className="sendmessageMic" style={{ marginTop: "-40%" }}>
                <AudioRecorder
                  onRecordingComplete={handleAudioRecordingComplete}
                  recorderControls={recorderControls}
                  showVisualizer={true}
                />
                <i
                  onClick={recorderControls.stopRecording}
                  disabled={loadingbuttonaudio || isButtonDisabled1}
                  className="bi bi-send"
                >
                  {loadingbuttonaudio && <Spinner />}
                </i>
              </div>
            </div>
          </div>
        </div>
        <Modal
          show={modalIsOpen}
          onHide={closeModal}
          centered
          dialogClassName="fullscreen-modal modelimage "
        >
          <Modal.Body className="p-0">
            <button className="close-btn" onClick={closeModal}>
              &times;
            </button>
            {selectedImage && (
              <img src={selectedImage} alt="Full slip" className="full-image" />
            )}
          </Modal.Body>
        </Modal>
      </section>
      <ToastContainer />
    </>
  );
}